// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CwcRq","right":"styles_right__3ybtk"};